export const TRIMS_FEATURES = {
  ford: {
    'f-150': {
      2026: {
        xl: 'Work-truck base with 17-in wheels, vinyl floors',
        stx: 'Adds 20-in wheels and carpet',
        xlt: 'Adds alloy wheels and digital cluster',
        lariat: 'Heated seats, leather, and BlueCruise',
        tremor: 'Off-road trim with 33-in all-terrain tires',
        'king-ranch': 'Massaging seats and 14-speaker B&O',
        platinum: 'Upgrades to real leather and heated rear seats',
        raptor: 'High-output V6, Fox shocks, 35-in tires',
        'raptor-r': 'Supercharged V8 with 37-in tires',
      },
    },
    maverick: {
      2026: {
        xl: 'FWD hybrid pickup; 38 MPG combined',
        xlt: 'Adds comfort and infotainment upgrades',
        lobo: 'Upgrades to AWD; EcoBoost; 24 MPG',
        lariat: 'Adds premium interior; AWD hybrid; 36 MPG',
        tremor: 'Off-road package; gas EcoBoost; 23 MPG',
      },
    },
    ranger: {
      2026: {
        xl: 'Work truck; 5 seats, tow 7,500 lb',
        xlt: 'Adds convenience and comfort',
        lariat: 'Premium interior and tech upgrade',
        raptor: '4WD high-performance off-road trim',
      },
    },
  },
  genesis: {
    gv70: {
      2026: {
        '25t': 'AWD luxury SUV; 5 seats, 22 MPG',
        '25t-select': 'Adds premium features and tech',
        '25t-advanced': 'Advanced safety and luxury adds',
        '25t-sport-prestige': 'Sport styling + prestige features',
        '35t-sport-advanced': 'V6 turbo upgrade; 21 MPG',
        '35t-sport-prestige': 'Top V6 with prestige package',
      },
    },
  },
  honda: {
    accord: {
      2026: {
        lx: 'FWD gas sedan; 5 seats, 32 MPG',
        se: 'Style upgrades; 31 MPG',
        'sport-hybrid': 'Hybrid upgrade; 44 MPG',
        'ex-l-hybrid': 'Leather interior; 48 MPG',
        'sport-l-hybrid': 'Sport-L features added; 44 MPG',
        'touring-hybrid': 'Top tech and safety package',
      },
    },
    civic: {
      2026: {
        lx: 'FWD 5-seat gas sedan; 36 MPG combined',
        sport: 'Adds sport styling and larger touchscreen',
        'sport-hybrid': 'Hybrid powertrain; 49 MPG combined',
        si: 'Gas; 6-speed manual; sporty performance',
        'sport-touring-hybrid': 'Hybrid; adds wireless charging and HUD',
        'type-r': 'Track-focused; 4 seats; 24 MPG combined',
      },
    },
    'cr-v': {
      2026: {
        lx: '5-seat gas SUV; 30 MPG combined',
        ex: 'Adds heated seats and remote start',
        'ex-l': 'Adds leather seats and moonroof',
        'sport-hybrid': 'Hybrid powertrain; 40 MPG combined',
        'sport-l-hybrid': 'Adds panoramic moonroof, ventilated seats',
        'trailsport-hybrid': 'AWD only; off-road suspension and tires',
        'sport-touring-hybrid': 'Adds HUD, heated steering, premium tech',
      },
    },
    passport: {
      2026: {
        rtl: 'AWD 5-seat gas SUV; 21 MPG combined',
        'rtl-towing': 'Adds towing prep package',
        'rtl-blackout': 'Adds blacked-out exterior trim package',
        trailsport: 'Off-road tuning; all-terrain tires',
        'trailsport-blackout': 'Adds blacked-out exterior styling',
        'trailsport-elite': 'Adds premium audio and advanced safety',
        'trailsport-elite-blackout': 'Adds blacked-out exterior styling',
      },
    },
    pilot: {
      2026: {
        sport: 'FWD 3-row SUV; 8 seats, 22 MPG',
        'ex-l': 'Adds leather and premium features',
        trailsport: 'AWD off-road trim; tow 5,000 lb',
        touring: 'Luxury features; returns to 8 seats',
        'touring-blackout': 'Blacked-out appearance upgrade',
        elite: 'Adds panoramic roof and top tech',
        'black-edition': 'Black styling on Elite trim',
      },
    },
  },
  hyundai: {
    'ioniq-5': {
      2026: {
        'se-standard-range': 'RWD EV; 245-mi range; 6.3-hr 240V charge',
        se: 'Longer range; 318 mi; 9.1-hr 240V charge',
        sel: 'Adds heated front seats and wireless charge',
        limited: 'Adds leather, sunroof, and premium audio',
        xrt: 'AWD only; off-road styling; 259-mi range',
      },
    },
    kona: {
      2026: {
        se: '5-seat gas subcompact SUV; 31 MPG',
        'sel-sport': 'Adds sportier styling and alloy wheels',
        'sel-premium': 'Adds turbo engine and premium features',
        limited: 'Adds panoramic sunroof and premium interior',
      },
    },
    palisade: {
      2026: {
        se: '3-row gas SUV; 8 seats; 21 MPG combined',
        sel: 'Adds heated front seats and safety tech',
        'sel-convenience': 'Adds heated second row and power liftgate',
        'hybrid-blue-sel': 'Hybrid; 34 MPG combined',
        'sel-premium': 'Gas; adds panoramic sunroof, premium audio',
        'hybrid-sel': 'Hybrid AWD; 29 MPG combined',
        'hybrid-blue-sel-premium': 'FWD hybrid; 34 MPG; premium features',
        'hybrid-sel-premium': 'AWD hybrid; adds premium interior tech',
        limited: 'Gas; top trim with full luxury suite',
        'xrt-pro': 'AWD only; off-road trim; 19 MPG',
        'hybrid-limited': 'Hybrid; 31 MPG; premium luxury features',
        calligraphy: 'Gas; top luxury with quilted leather',
        'hybrid-calligraphy': 'Hybrid; 31 MPG combined',
      },
    },
    'santa-fe': {
      2026: {
        se: '3-row SUV; 7 seats, 24 MPG',
        'se-hybrid': 'Hybrid engine; 36 MPG',
        sel: 'More features; gas, 24 MPG',
        'sel-hybrid': 'Hybrid version of SEL; 36 MPG',
        xrt: 'AWD; off-road style, tow 4,500 lb',
        limited: 'Premium cabin; 6 seats, 24 MPG',
        'limited-hybrid': 'Hybrid on Limited; 36 MPG',
        calligraphy: 'Top luxury trim; gas, 24 MPG',
        'calligraphy-hybrid': 'Calligraphy + hybrid; 36 MPG',
      },
    },
    tucson: {
      2026: {
        se: '5-seat gas SUV; 28 MPG combined',
        sel: 'Adds blind-spot monitoring and more tech',
        'hybrid-se': 'Hybrid powertrain; 38 MPG combined',
        'sel-plus': 'Gas; adds wireless charging, heated rear',
        'hybrid-sel': 'Hybrid upgrade; 36 MPG combined',
        'hybrid-blue-se': 'AWD only hybrid; 38 MPG combined',
        xrt: 'Gas off-road trim; all-terrain styling',
        'sel-premium': 'Gas; adds sunroof and premium interior',
        'hybrid-sel-convenience': 'Hybrid AWD; adds heated and cooled seats',
        limited: 'Gas; adds HUD, ventilated seats, LED lamps',
        'hybrid-limited': 'Hybrid AWD version of Limited; 36 MPG',
        'hybrid-night': 'Adds dark chrome exterior styling package',
      },
    },
  },
  kia: {
    'sportage-hybrid': {
      2026: {
        lx: 'FWD 5-seat hybrid SUV; 42 MPG combined',
        s: 'Adds AWD and safety tech; 35 MPG combined',
        ex: 'Adds push-button start and wireless charge',
        'x-line': 'Adds adventure styling and roof rails',
        'sx-prestige': 'Adds sunroof, premium audio, heated rear',
      },
    },
    telluride: {
      2027: {
        lx: 'FWD 3-row SUV; 8 seats',
        s: "Captain's chairs; 7-seat layout",
        ex: 'Adds features; returns to 8 seats',
        'x-line-ex': 'AWD + rugged X-Line styling',
        sx: 'Premium tech and features; FWD',
        'x-line-sx': 'AWD + X-Line style on SX',
        'x-pro-sx': 'Enhanced off-road on X-Line SX',
        'sx-prestige': 'Luxury upgrade over X-Pro SX',
        'x-line-sx-prestige': 'X-Line style on SX-Prestige',
        'x-pro-sx-prestige': 'X-Pro off-road on SX-Prestige',
      },
    },
  },
  lexus: {
    rx: {
      2026: {
        350: 'Turbo gas; 5 seats, 25 MPG',
        '350-premium': 'Adds premium cabin features',
        '350h': 'AWD hybrid upgrade; 36 MPG',
        '350h-premium': 'Premium features on hybrid',
        '350-f-sport-design': 'Sport-styled gas trim; FWD only',
        '350-premium-plus': 'More luxury content than F SPORT',
        '350h-f-sport-design': 'AWD hybrid + F SPORT styling',
        '350h-premium-plus': 'Premium luxury on AWD hybrid',
        '350-f-sport-handling': 'Gas AWD; performance-tuned sport',
        '350-luxury': 'Top luxury package; gas model',
        '350h-luxury': 'Top luxury on AWD hybrid',
        '450hplus-premium': 'PHEV; 38 mi electric range',
        '500h-f-sport-performance': 'Performance sport hybrid; 27 MPG',
        '450hplus-luxury': 'PHEV luxury; 38 mi electric range',
      },
    },
  },
  mazda: {
    'cx-5': {
      2026: {
        '25-s': 'AWD; 2.5L gas; 5 seats; 25 MPG combined',
        '25-s-select': 'Adds safety tech and audio upgrades',
        '25-s-preferred': 'Heated seats; 28 MPG combined',
        '25-s-premium': 'Leather, sunroof, and Bose audio',
        '25-s-premium-plus': 'Adds HUD and surround-view camera',
      },
    },
    'cx-50': {
      2026: {
        '25-s-select': 'AWD crossover; 5 seats, 26 MPG',
        '25-s-preferred': 'Adds comfort and convenience',
        '25-s-meridian-edition': 'Special edition styling upgrade',
        'hybrid-preferred': 'Hybrid engine upgrade; 38 MPG',
        '25-s-premium': 'Premium features; gas, 26 MPG',
        '25-turbo': 'Turbo engine; tow 3,500 lb',
        'hybrid-premium': 'Hybrid with premium trim; 38 MPG',
        '25-turbo-meridian-edition': 'Special edition on Turbo',
        'hybrid-premium-plus': 'Adds luxury to hybrid; 38 MPG',
        '25-turbo-premium-plus': 'Top turbo trim; tow 3,500 lb',
      },
    },
  },
  'mercedes-benz': {
    gle: {
      2026: {
        'gle-350': 'RWD mild hybrid; 2.0L 4-cyl; 23 MPG',
        'gle-350-4matic': 'Adds 4MATIC AWD; 22 MPG combined',
        'gle-450-4matic': 'Upgrades to inline-6 engine; 21 MPG',
        'gle-450e': 'Plug-in hybrid; 50 mi electric range',
        'gle-580-4matic': 'V8 power replaces plug-in hybrid',
        'amg-gle-53': 'AMG sport package; inline-6; 20 MPG',
        'amg-gle-63-s': 'Full AMG V8 bi-turbo; 17 MPG',
      },
    },
  },
  subaru: {
    crosstrek: {
      2026: {
        base: 'AWD compact SUV; 5 seats, 29 MPG',
        premium: 'Adds safety tech and sunroof',
        sport: 'Sport styling; added tech features',
        limited: 'Leather interior; full safety suite',
        wilderness: 'Off-road tuned; tow 3,500 lb',
        'sport-hybrid': 'Hybrid engine upgrade; 36 MPG',
        'limited-hybrid': 'Premium features on hybrid trim',
      },
    },
    forester: {
      2026: {
        base: 'AWD; 2.5L gas; 5 seats; 29 MPG combined',
        premium: 'Adds EyeSight safety and power moonroof',
        'premium-hybrid': 'Upgrades to hybrid engine; 35 MPG',
        sport: 'Sport styling; gas engine; 28 MPG',
        limited: 'Leather interior and premium infotainment',
        'sport-hybrid': 'Sport look with hybrid power; 35 MPG',
        wilderness: 'Off-road package; raised ride; 26 MPG',
        'limited-hybrid': 'Luxury interior; hybrid engine; 35 MPG',
        'touring-hybrid': 'Adds premium audio and top-tier tech',
        touring: 'Gas powertrain; same trim level; 28 MPG',
      },
    },
    outback: {
      2026: {
        premium: 'AWD 5-seat gas wagon; 27 MPG combined',
        limited: 'Adds leather, sunroof, and premium audio',
        'limited-xt': 'Turbo engine; 24 MPG combined',
        wilderness: 'Off-road tuning; 23 MPG combined',
        touring: 'Luxury-focused; adds Harman Kardon audio',
        'touring-xt': 'Turbo engine; adds nav and premium tech',
      },
    },
  },
  tesla: {
    'model-y': {
      2026: {
        base: '5-seat EV; 321-mi range; 10-hr 240V charge',
        standard: 'AWD; faster acceleration',
        'long-range': 'RWD; extends range to 357 miles',
        premium: 'AWD; 327-mi range; 8-hr 240V charge',
        performance: 'Sport-tuned AWD; higher output motors',
        'long-range-launch-series': 'Launch edition AWD; premium features',
      },
    },
  },
  toyota: {
    '4runner': {
      2026: {
        sr5: '2.4L turbo gas; 5 seats; 22 MPG',
        'trd-sport': 'Sport suspension and TRD styling pkg',
        'trd-off-road': '4WD-only; crawl control; locking diff',
        'trd-sport-premium': 'Upgrades TRD Sport with premium comfort',
        'trd-off-road-premium': '4WD off-road gear with premium features',
        limited: 'Luxury interior over TRD off-road focus',
        platinum: 'Upgrades to 4WD hybrid; 23 MPG',
        trailhunter: 'Adds factory off-road expedition build',
        'trd-pro': 'Fox coilover shocks and TRD off-road',
      },
    },
    camry: {
      2026: {
        le: '5-seat hybrid sedan; 51 MPG combined',
        se: 'Sport styling; heated front seats',
        nightshade: 'Sport-dark exterior styling package',
        xle: 'Adds leather, sunroof, wireless charging',
        xse: 'Adds sport-tuned suspension and shifter',
      },
    },
    'grand-highlander': {
      2026: {
        le: 'FWD 3-row SUV; 8 seats, 24 MPG',
        xle: '7-seat captains; adds safety tech',
        limited: 'Adds premium interior features',
        platinum: 'AWD; top luxury trim, 22 MPG',
      },
    },
    'grand-highlander-hybrid': {
      2026: {
        le: 'AWD 3-row hybrid; 8 seats; 34 MPG',
        xle: '7-seat; adds larger screen and sunroof',
        limited: 'AWD; adds leather and heated/cooled seats',
        nightshade: 'Adds blacked-out exterior styling',
        'max-limited': 'Turbo hybrid; 5,000-lb towing; 27 MPG',
        'max-platinum': 'Adds premium audio and advanced tech',
      },
    },
    rav4: {
      2026: {
        le: '5-seat hybrid SUV; 43 MPG combined',
        se: 'Adds sport styling and heated front seats',
        'xle-premium': 'Adds leather, sunroof, and larger screen',
        woodland: 'AWD only; off-road tuning; 38 MPG',
        xse: 'Sporty AWD; blacked-out exterior trim',
        limited: 'Adds panoramic roof and premium interior',
      },
    },
    tacoma: {
      2026: {
        sr: 'Work truck; 228-hp turbo, leaf springs',
        sr5: 'Upgrades to 278-hp engine and alloy wheels',
        'trd-prerunner': 'Lifted suspension, locking diff, underbody guard',
        'trd-sport': 'Sport-tuned suspension; 18-inch wheels',
        'trd-off-road': 'Bilstein dampers, skidplates, all-terrain tires',
        limited: 'Heated leather seats, sunroof, 14-in screen',
        trailhunter: 'ARB bed bar, rock rails, more underbody armor',
        'trd-pro': 'Fox dampers, 33-in tires, swaybar disconnect',
      },
    },
  },
};
